import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import LoadingCenter from '../../../Components/LoadingCenter';
import DeleteButton from '../../../Components/DeleteButton';
import ProgramHeader from '../../../Components/ProgramHeader';
import BackButtonRouter from '../../../Components/BackButtonRouter';

import APIGet from '../../../API/APIGet';
import APIPost from '../../../API/APIPost';
import APIPut from '../../../API/APIPut';
import APIDelete from '../../../API/APIDelete';
import APIHelper from '../../../Helper/APIHelper';
import ThingsToSelect from '../../../Helper/ThingsToSelect';
import AuthHelper from '../../../Helper/AuthHelper';
import AdminLockRender from '../../../Helper/AdminLockRender';
import TravelerHelper from '../../../Helper/Traveler';

import AppConfig from '../../../AppConfig';

import Summary from './Summary';
import IncomeCustomer from './IncomeCustomer';
import IncomeEtc from './IncomeEtc';
import Expense from './Expense';
import Budget from './Budget';
import Restaurant from './Restaurant';
import Traveler from './Traveler';

export default class IncentiveProgramDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoadingProgram: true,
			isLoadingIncome: true,
			isLoadingIncomeEtc: true,
			isLoadingExpense: true,
			isLoadingBudget: true,
			isLoadingRestaurant: true,
			isLoadingTraveler: true,
			program: null,
			incomeEtc: [],
			incomes: [],
			expenseGroup: null,
			staffs: [],
			budgets: [],
			restaurants: null,
			travelers: [],
			initTravelers: [],
		};
	}

	async componentDidMount() {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			this.getProgram();
			this.getIncome();
			this.getIncomeEtc();
			this.getExpenseGroup();
			this.getBudget();
			this.getTraveler();
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	}

	getProgram = async () => {
		const { programId } = this.props.match.params;

		let requestProgram = APIGet('incentive/programs/' + programId);
		let requestStaffs = APIGet('staffs');
		requestProgram = await requestProgram;
		requestStaffs = await requestStaffs;
		if (APIHelper.handleAPIResponse(this, requestProgram, requestStaffs)) {
			const program = requestProgram.data;
			const staffs = ThingsToSelect(requestStaffs.data);
			// console.log('program: ', program);
			// console.log('staffs: ', staffs);
			this.setState({
				isLoadingProgram: false,
				program,
				staffs,
			});
		} else if (requestProgram.status === 404) {
			toast.warning('ไม่พบโปรแกรมดังกล่าว');
		} else {
			toast.error('ไม่สามารถดึงข้อมูลโปรแกรมได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getIncome = async () => {
		const { programId } = this.props.match.params;

		const request = await APIGet('incentive/programs/' + programId + '/incomes');
		if (APIHelper.handleAPIResponse(this, request)) {
			const incomes = request.data;
			// console.log('incomes: ', incomes);
			this.setState({
				isLoadingIncome: false,
				incomes,
			});
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูลรายรับ');
		} else {
			toast.error('ไม่สามารถดึงข้อมูลรายรับได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getIncomeEtc = async () => {
		const { programId } = this.props.match.params;

		const request = await APIGet('incentive/programs/' + programId + '/incomeEtcs');
		if (APIHelper.handleAPIResponse(this, request)) {
			const incomeEtcs = request.data;
			// console.log('incomeEtcs: ', incomeEtcs);
			this.setState({
				isLoadingIncomeEtc: false,
				incomeEtcs,
			});
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูลรายรับ');
		} else {
			toast.error('ไม่สามารถดึงข้อมูลรายรับได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getExpenseGroup = async () => {
		const { programId } = this.props.match.params;

		const request = await APIGet('incentive/programs/' + programId + '/expenses');
		if (APIHelper.handleAPIResponse(this, request)) {
			const expenseGroup = request.data;
			// console.log('expenseGroup: ', expenseGroup);
			this.setState({
				isLoadingExpense: false,
				expenseGroup,
			});
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูลรายรับ');
		} else {
			toast.error('ไม่สามารถดึงข้อมูลรายรับได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getBudget = async () => {
		const { programId } = this.props.match.params;

		const request = await APIGet('incentive/programs/' + programId + '/budgets');
		if (APIHelper.handleAPIResponse(this, request)) {
			const budgets = request.data;
			// console.log('budgets: ', budgets);
			this.setState({
				isLoadingBudget: false,
				budgets,
			});
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูล Budget');
		} else {
			toast.error('ไม่สามารถดึงข้อมูล Budget ได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getRestaurant = async () => {
		const { programId } = this.props.match.params;

		const request = await APIGet('incentive/programs/' + programId + '/restaurants');
		if (APIHelper.handleAPIResponse(this, request)) {
			const restaurants = request.data;
			// console.log('restaurants: ', restaurants);
			this.setState({
				isLoadingRestaurant: false,
				restaurants,
			});
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูลร้านอาหาร');
		} else {
			toast.error('ไม่สามารถดึงข้อมูลร้านอาหารได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	getTraveler = async () => {
		const { programId } = this.props.match.params;
		const request = await APIGet('incentive/programs/' + programId + '/travelers');
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			const travelers = Array.isArray(responseData) ? responseData : responseData.data || [];
			// console.log('programs travelers: ', travelers);
			this.setState({
				isLoadingTraveler: false,
				travelers,
			});

			await this.getInitTravelers(travelers);
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูล Traveler');
		} else {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ได้ กรุณาลองใหม่อีกครั้ง');
			return;
		}
	};

	getInitTravelers = async existingTravelers => {
		let allTravelerResponse = [];
		const request = await APIGet('travelers?page=1&perPage=40');
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			allTravelerResponse = Array.isArray(responseData) ? responseData : responseData.data || [];
			// console.log('allTravelerResponse: ', allTravelerResponse);
		} else if (request.status === 404) {
			toast.warning('ไม่พบข้อมูล Traveler');
		} else {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ทั้งหมดได้กรุณาลองใหม่อีกครั้ง');
			return;
		}

		const allTravelerResults = [];

		for (const traveler of allTravelerResponse) {
			if (existingTravelers && existingTravelers.length > 0) {
				const existingTraveler = existingTravelers.find(t => t.id === traveler.id);
				if (existingTraveler != null) continue;
			}

			allTravelerResults.push({
				value: traveler.id,
				label: TravelerHelper.getNameAndContact(traveler),
			});
		}

		// console.log('allTravelerResults: ', allTravelerResults);
		this.setState({
			isLoadingTraveler: false,
			initTravelers: allTravelerResults,
		});
	};

	onProgramUpdated = program => {
		this.setState({
			program,
		});
	};

	onAddTraveler = async traveler => {
		const { programId } = this.props.match.params;
		const request = await APIPost('incentive/programs/' + programId + '/travelers', {
			travelerId: traveler.value,
		});
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			const travelers = Array.isArray(responseData) ? responseData : responseData.data || [];
			// console.log('traveler: ', travelers);
			this.setState({
				travelers: travelers,
			});
			toast.success('เพิ่ม Traveler สำเร็จ');
			// await this.getInitTravelers(travelers);
			await this.getTraveler();
		} else {
			toast.error('ไม่สามารถเพิ่ม Traveler ได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	onDeleteTraveler = async travelerId => {
		const { programId } = this.props.match.params;
		const request = await APIDelete('incentive/programs/' + programId + '/travelers/' + travelerId);
		if (APIHelper.handleAPIResponse(this, request)) {
			const responseData = request.data;
			const travelers = Array.isArray(responseData) ? responseData : responseData.data || [];
			this.setState({
				travelers: travelers,
			});
			// console.log('travelers: ', travelers);
			toast.success('ลบ Traveler เรียบร้อยแล้ว');
			// await this.getInitTravelers(this.state.travelers);
			await this.getTraveler();
		} else {
			toast.error('ไม่สามารถลบ Traveler ได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	onRearrangeTravelers = async travelerIds => {
		const { programId } = this.props.match.params;
		const request = await APIPut('incentive/programs/' + programId + '/travelers/sort', {
			travelerIds,
		});
		if (APIHelper.handleAPIResponse(this, request)) {
			toast.success('จัดลำดับ Traveler แล้ว');
			await this.getTraveler();
		} else {
			toast.error('ไม่สามารถจัดลำดับ Traveler ได้ กรุณาลองใหม่อีกครั้ง');
		}
	};

	delete = async () => {
		const { programId } = this.props.match.params;
		this.setState({
			isLoading: true,
		});

		let requestDelete = APIDelete('incentive/programs/' + programId);
		requestDelete = await requestDelete;
		if (APIHelper.handleAPIResponse(this, requestDelete)) {
			toast.success('ลบเรียบร้อยแล้ว');
			this.props.history.replace(AppConfig.appPath + '/programs/incentive');
		} else {
			toast.error('ไม่สามารถลบได้ กรุณาลองใหม่อีกครั้ง');
			this.setState({
				isLoading: false,
			});
		}
	};

	render() {
		if (this.state.isLoadingProgram) {
			return <LoadingCenter />;
		}

		const { program, incomes, expenseGroup, incomeEtcs, staffs, budgets, restaurants, travelers, initTravelers } = this.state;
		const { programId } = this.props.match.params;

		if (!program) {
			return <div>Error</div>;
		}

		return (
			<div className="container">
				<BackButtonRouter link={AppConfig.appPath + '/programs/incentive'} title="INCENTIVE" />
				<ProgramHeader program={program} />

				<div className="columns row">
					<div className="column is-6">
						{AdminLockRender(
							program.status,
							<Link className="button is-info" to={AppConfig.appPath + '/programs/incentive/' + programId + '/edit'}>
								แก้ไข
							</Link>,
							<button className="button is-info" disabled>
								แก้ไข
							</button>
						)}
					</div>
					<div className="column is-6" style={{ textAlign: 'right' }}>
						{AdminLockRender(program.status, <DeleteButton label="ลบ" warningMessage="ยืนยันการลบ" onClick={this.delete} />, null)}
					</div>
				</div>

				<br />

				<Summary
					program={program}
					onProgramUpdated={this.onProgramUpdated}
					staffs={staffs}
					incomes={incomes}
					incomeEtcs={incomeEtcs}
					expenseGroup={expenseGroup}
				/>

				{!this.state.isLoadingIncome ? <IncomeCustomer incomes={incomes} program={program} programId={programId} /> : <LoadingCenter />}

				{!this.state.isLoadingIncomeEtc ? <IncomeEtc program={program} programId={programId} incomeEtcs={incomeEtcs} /> : <LoadingCenter />}

				{!this.state.isLoadingExpense ? <Expense program={program} programId={programId} expenseGroup={expenseGroup} /> : <LoadingCenter />}

				{!this.state.isLoadingBudget ? <Budget program={program} programId={programId} budgets={budgets} /> : <LoadingCenter />}

				{!this.state.isLoadingBudget ? <Restaurant programId={programId} restaurants={restaurants} /> : <LoadingCenter />}

				{!this.state.isLoadingTraveler ? (
					<Traveler
						programId={programId}
						travelers={travelers}
						initTravelers={initTravelers}
						onAddTraveler={this.onAddTraveler}
						onDeleteTraveler={this.onDeleteTraveler}
						onRearrangeTravelers={this.onRearrangeTravelers}
					/>
				) : (
					<LoadingCenter />
				)}
			</div>
		);
	}
}
